import React from "react";
import { Phone, MapPin, Clock, Instagram } from "lucide-react";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_36d91178-24f3-40fc-9720-d06acab0d2e6/artifacts/9kjaww63_IMG_1194.jpg";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1A1813] text-white/90 pt-16 pb-8"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-white/10">
          {/* Brand */}
          <div className="md:col-span-5">
            <div className="flex items-center gap-4 mb-5">
              <div className="w-14 h-14 rounded-full overflow-hidden bg-[#F5EFE0]">
                <img
                  src={LOGO_URL}
                  alt="R Maart"
                  className="w-full h-full object-cover"
                />
              </div>
              <div>
                <div className="font-display text-2xl text-[#D4C47A] font-semibold">
                  R Maart
                </div>
                <div className="font-latin text-[11px] uppercase tracking-[0.25em] text-white/60">
                  Supermart · Partur
                </div>
              </div>
            </div>
            <p className="font-latin text-white/70 text-sm leading-relaxed max-w-md">
              Quality products, unbeatable prices, and trusted service —
              everything the people of Partur need, under one roof.
            </p>
          </div>

          {/* Quick links */}
          <div className="md:col-span-3">
            <div className="font-latin text-[11px] uppercase tracking-[0.25em] text-white/50 mb-4">
              Quick Links
            </div>
            <ul className="space-y-3 font-latin text-sm">
              <li><a href="#offers" className="hover:text-[#D4C47A] transition-colors">Offers</a></li>
              <li><a href="#categories" className="hover:text-[#D4C47A] transition-colors">Categories</a></li>
              <li><a href="#gallery" className="hover:text-[#D4C47A] transition-colors">Our Store</a></li>
              <li><a href="#why" className="hover:text-[#D4C47A] transition-colors">About Us</a></li>
              <li><a href="#location" className="hover:text-[#D4C47A] transition-colors">Visit</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <div className="font-latin text-[11px] uppercase tracking-[0.25em] text-white/50 mb-4">
              Contact
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#D4C47A] shrink-0" />
                <span className="font-latin text-white/80 leading-relaxed">
                  Watur Road, In Front of Mahavir Petrol Pump, Near Railway Station, Partur 431501
                </span>
              </li>
              <li className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#D4C47A] shrink-0" />
                <a href="tel:7278919919" className="font-latin text-white/80 hover:text-[#D4C47A]">
                  7278919919
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Clock className="w-4 h-4 text-[#D4C47A] shrink-0" />
                <span className="font-latin text-white/80">9 AM – 10 PM · Daily</span>
              </li>
              <li className="flex items-center gap-3">
                <Instagram className="w-4 h-4 text-[#D4C47A] shrink-0" />
                <a
                  href="https://instagram.com/rmaartpartur"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="font-latin text-white/80 hover:text-[#D4C47A]"
                >
                  @rmaartpartur
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-white/50">
          <div className="font-latin">
            © {new Date().getFullYear()} R Maart. All rights reserved.
          </div>
          <div className="font-latin tracking-wider">
            A unit of <span className="text-white/80">RYRR Ventures LLP</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
